import { createI18n } from 'vue-i18n';
import getStartingLocale from './get-starting-locale';
import { LANG_STORAGE_KEY, LANGUAGES } from '../../constants';
import { pluralizeRu, pluralizeEn } from '../../functions';
import getSupportedLocales from './get-supported-locales';
import { getCountryByDomain } from '@/utils/functions/get-country-by-domain';

export type Locale = 'ru' | 'kk' | 'en' | 'ka' | 'hi' | 'zh' | 'uz' | 'tr';

const countryConfig = getCountryByDomain();
const supportedLocales = getSupportedLocales(countryConfig.supportedLanguages);
const defaultLocale = countryConfig.defaultLocale || 'kk';
const fallbackLocale = countryConfig.fallbackLocale || 'ru';

export const SUPPORTED_LANGS =
	LANGUAGES.filter(lang => supportedLocales.includes(lang.code)) || LANGUAGES;

const i18n = createI18n({
	legacy: false,
	locale: getStartingLocale(defaultLocale),
	globalInjection: true,
	fallbackLocale: fallbackLocale,
	pluralRules: {
		ru: pluralizeRu,
		kk: pluralizeRu,
		en: pluralizeEn,
		ka: pluralizeEn,
		hi: pluralizeEn,
		zh: pluralizeEn,
		uz: pluralizeEn,
		tr: pluralizeEn
	},
	messages: SUPPORTED_LANGS.reduce<
		Record<string, Record<string, string | object>>
	>((acc, lang) => {
		if (!acc[lang.code]) {
			acc[lang.code] = lang.messages;
		}

		return acc;
	}, {})
});

/**
 * Изменение языка глобально и в хранилище клиента
 */
export function setLocaleToStorage(value: string) {
	localStorage.setItem(LANG_STORAGE_KEY, value);
}

export function needToDetermineLanguage() {
	return !localStorage.getItem(LANG_STORAGE_KEY);
}

export default i18n;
